import CurrencyValue from "@/components/tableElements/CurrencyValue.vue";
import NumberValue from "@/components/tableElements/NumberValue.vue";
import LoadingElement from "@/components/shared/LoadingElement.vue";
export default {
  name: "KpiCard",
  components: {
    CurrencyValue,
    LoadingElement,
    NumberValue
  },
  props: {
    type: String,
    component: String,
    value: [Number, null],
    loading: Boolean
  }
};